import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProcessingFees = () => {
    return (
        <>
        {/* <ToastContainer position="top-center" autoClose={3000} /> */}
        
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">Processing Fees</h2>

            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Publication Fees:</div>
                <div className="about-ed-content-impact">
                    <p>
                        Authors can pay the processing fees using UPI, QR code scanner, Net Banking, Debit Card, or International Credit Card through the link provided below.
                    </p>
                    <div
                        className="publication-fees-btn-impact"
                        onClick={() => {
                            const login = JSON.parse(localStorage.getItem("isLoggedIn"));
                            if (!login) {
                              toast.success("Please log in to proceed with the payment.");
                              window.location.href = '/login-impact';
                            } else {
                              window.location.href = '/processing-fees-form';
                            }
                          }}
                    >
                        Proceed to payment
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ProcessingFees;
